var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"currentColor","x":"7.85547","y":"8","width":"4","height":"9","key":0}),React.createElement("rect",{"fill":"currentColor","x":"13.8555","y":"12","width":"4","height":"5","key":1}),React.createElement("rect",{"fill":"currentColor","x":"3.85547","y":"18","width":"18","height":"2","key":2})]);
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
